// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`SectionDetail renders the section correctly 1`] = `
<DocumentFragment>
  .emotion-0 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
}

.emotion-1 {
  padding: 16px;
}

.emotion-2 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 32px;
}

.emotion-3 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.emotion-4 {
  max-width: 600px;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

.emotion-5 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.emotion-6 {
  margin: 0;
  font-family: Open Sans;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
}

.emotion-7 {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  background-color: transparent;
  outline: 0;
  border: 0;
  margin: 0;
  border-radius: 0;
  padding: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  vertical-align: middle;
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-text-decoration: none;
  text-decoration: none;
  color: inherit;
  text-align: center;
  -webkit-flex: 0 0 auto;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  font-size: 1.5rem;
  padding: 8px;
  border-radius: 50%;
  overflow: visible;
  color: rgba(0, 0, 0, 0.54);
  -webkit-transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

.emotion-7::-moz-focus-inner {
  border-style: none;
}

.emotion-7.Mui-disabled {
  pointer-events: none;
  cursor: default;
}

@media print {
  .emotion-7 {
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
  }
}

.emotion-7:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

@media (hover: none) {
  .emotion-7:hover {
    background-color: transparent;
  }
}

.emotion-7.Mui-disabled {
  background-color: transparent;
  color: #1C1B1F61;
}

.emotion-8 {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 1em;
  height: 1em;
  display: inline-block;
  fill: currentColor;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-size: 1.5rem;
}

.emotion-9 {
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  z-index: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: inherit;
}

.emotion-10 {
  margin: 0;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  border-width: 0;
  border-style: solid;
  border-color: #D6D5DD;
  border-bottom-width: thin;
}

.emotion-11 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  overflow-y: auto;
  padding: 24px;
  gap: 8px;
}

.emotion-12 {
  background-color: #FCFAFD;
  color: #1C1B1F;
  -webkit-transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border-radius: 8px;
  box-shadow: none;
  background-image: none;
  border-radius: 24px;
  overflow: hidden;
  background-color: #F1ECF4;
}

.emotion-13 {
  padding: 16px;
}

.emotion-13:last-child {
  padding-bottom: 24px;
}

.emotion-14 {
  margin: 0;
  font-family: Open Sans;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 0.35em;
}

.emotion-15 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 8px;
}

.emotion-16 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 4px;
}

.emotion-17 {
  margin: 0;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}

.emotion-18 {
  margin: 0;
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 0.35em;
}

.emotion-19 {
  position: relative;
}

.emotion-20 {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  position: relative;
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
  vertical-align: top;
  width: 100%;
}

.emotion-21 {
  color: #1C1B1F;
  line-height: 1.4375em;
  box-sizing: border-box;
  position: relative;
  cursor: text;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 4px 0 5px;
  width: 100%;
  position: relative;
  border-radius: 8px;
  padding: 16.5px 14px;
}

.emotion-21.Mui-disabled {
  color: #1C1B1F61;
  cursor: default;
}

.emotion-21:hover .MuiOutlinedInput-notchedOutline {
  border-color: #1C1B1F;
}

@media (hover: none) {
  .emotion-21:hover .MuiOutlinedInput-notchedOutline {
    border-color: rgba(0, 0, 0, 0.23);
  }
}

.emotion-21.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #4B35FF;
  border-width: 2px;
}

.emotion-21.Mui-error .MuiOutlinedInput-notchedOutline {
  border-color: #BA1A1A;
}

.emotion-21.Mui-disabled .MuiOutlinedInput-notchedOutline {
  border-color: #1C1B1F61;
}

.emotion-22 {
  font: inherit;
  letter-spacing: inherit;
  color: currentColor;
  padding: 0;
  border: 0;
  box-sizing: content-box;
  background: none;
  height: auto;
  margin: 0;
  -webkit-tap-highlight-color: transparent;
  display: block;
  min-width: 0;
  width: 100%;
  -webkit-animation-name: mui-auto-fill-cancel;
  animation-name: mui-auto-fill-cancel;
  -webkit-animation-duration: 10ms;
  animation-duration: 10ms;
  resize: none;
  padding-top: 0;
  padding: 0;
}

.emotion-22::-webkit-input-placeholder {
  color: currentColor;
  opacity: 0.42;
  -webkit-transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

.emotion-22::-moz-placeholder {
  color: currentColor;
  opacity: 0.42;
  -webkit-transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

.emotion-22:-ms-input-placeholder {
  color: currentColor;
  opacity: 0.42;
  -webkit-transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

.emotion-22::-ms-input-placeholder {
  color: currentColor;
  opacity: 0.42;
  -webkit-transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

.emotion-22:focus {
  outline: 0;
}

.emotion-22:invalid {
  box-shadow: none;
}

.emotion-22::-webkit-search-decoration {
  -webkit-appearance: none;
}

label[data-shrink=false]+.MuiInputBase-formControl .emotion-22::-webkit-input-placeholder {
  opacity: 0!important;
}

label[data-shrink=false]+.MuiInputBase-formControl .emotion-22::-moz-placeholder {
  opacity: 0!important;
}

label[data-shrink=false]+.MuiInputBase-formControl .emotion-22:-ms-input-placeholder {
  opacity: 0!important;
}

label[data-shrink=false]+.MuiInputBase-formControl .emotion-22::-ms-input-placeholder {
  opacity: 0!important;
}

label[data-shrink=false]+.MuiInputBase-formControl .emotion-22:focus::-webkit-input-placeholder {
  opacity: 0.42;
}

label[data-shrink=false]+.MuiInputBase-formControl .emotion-22:focus::-moz-placeholder {
  opacity: 0.42;
}

label[data-shrink=false]+.MuiInputBase-formControl .emotion-22:focus:-ms-input-placeholder {
  opacity: 0.42;
}

label[data-shrink=false]+.MuiInputBase-formControl .emotion-22:focus::-ms-input-placeholder {
  opacity: 0.42;
}

.emotion-22.Mui-disabled {
  opacity: 1;
  -webkit-text-fill-color: #1C1B1F61;
}

.emotion-22:-webkit-autofill {
  -webkit-animation-duration: 5000s;
  animation-duration: 5000s;
  -webkit-animation-name: mui-auto-fill;
  animation-name: mui-auto-fill;
}

.emotion-22:-webkit-autofill {
  border-radius: inherit;
}

.emotion-24 {
  text-align: left;
  position: absolute;
  bottom: 0;
  right: 0;
  top: -5px;
  left: 0;
  margin: 0;
  padding: 0 8px;
  pointer-events: none;
  border-radius: inherit;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  min-width: 0%;
  border-color: rgba(0, 0, 0, 0.23);
}

.emotion-25 {
  float: unset;
  width: auto;
  overflow: hidden;
  padding: 0;
  line-height: 11px;
  -webkit-transition: width 150ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
  transition: width 150ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
}

.emotion-29 {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  position: relative;
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
  vertical-align: top;
  padding-left: 8px;
}

.emotion-30 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  gap: 8px;
}

.emotion-31 {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  cursor: pointer;
  vertical-align: middle;
  -webkit-tap-highlight-color: transparent;
  margin-left: -11px;
  margin-right: 16px;
}

.emotion-31.Mui-disabled {
  cursor: default;
}

.emotion-31 .MuiFormControlLabel-label.Mui-disabled {
  color: #1C1B1F61;
}

.emotion-32 {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  background-color: transparent;
  outline: 0;
  border: 0;
  margin: 0;
  border-radius: 0;
  padding: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  vertical-align: middle;
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-text-decoration: none;
  text-decoration: none;
  color: inherit;
  padding: 9px;
  border-radius: 50%;
  color: #1C1B1FB3;
}

.emotion-32::-moz-focus-inner {
  border-style: none;
}

.emotion-32.Mui-disabled {
  pointer-events: none;
  cursor: default;
}

@media print {
  .emotion-32 {
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
  }
}

.emotion-32:hover {
  background-color: rgba(75, 53, 255, 0.04);
}

@media (hover: none) {
  .emotion-32:hover {
    background-color: transparent;
  }
}

.emotion-32.Mui-checked {
  color: #4B35FF;
}

.emotion-32.Mui-disabled {
  color: #1C1B1F61;
}

.emotion-33 {
  cursor: inherit;
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  z-index: 1;
}

.emotion-34 {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.emotion-35 {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 1em;
  height: 1em;
  display: inline-block;
  fill: currentColor;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-size: 1.25rem;
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
}

.emotion-36 {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 1em;
  height: 1em;
  display: inline-block;
  fill: currentColor;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-size: 1.25rem;
  left: 0;
  position: absolute;
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
  -webkit-transition: -webkit-transform 150ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
  transition: transform 150ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
}

.emotion-38 {
  margin: 0;
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.emotion-39 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  gap: 16px;
}

.emotion-45 {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 1em;
  height: 1em;
  display: inline-block;
  fill: currentColor;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-size: 1.25rem;
  left: 0;
  position: absolute;
  -webkit-transform: scale(0);
  -moz-transform: scale(0);
  -ms-transform: scale(0);
  transform: scale(0);
  -webkit-transition: -webkit-transform 150ms cubic-bezier(0.4, 0, 1, 1) 0ms;
  transition: transform 150ms cubic-bezier(0.4, 0, 1, 1) 0ms;
}

.emotion-48 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  max-width: 600px;
  gap: 16px;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
}

.emotion-49 {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  background-color: transparent;
  outline: 0;
  border: 0;
  margin: 0;
  border-radius: 0;
  padding: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  vertical-align: middle;
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-text-decoration: none;
  text-decoration: none;
  color: inherit;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-transform: none;
  min-width: 64px;
  padding: 5px 15px;
  border-radius: 8px;
  -webkit-transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border: 1px solid rgba(75, 53, 255, 0.5);
  color: #4B35FF;
  box-shadow: none;
  border-radius: 100px;
  text-transform: none;
  padding: 10px 24px;
  white-space: nowrap;
  min-width: -webkit-max-content;
  min-width: -moz-max-content;
  min-width: max-content;
  min-width: 156px;
}

.emotion-49::-moz-focus-inner {
  border-style: none;
}

.emotion-49.Mui-disabled {
  pointer-events: none;
  cursor: default;
}

@media print {
  .emotion-49 {
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
  }
}

.emotion-49:hover {
  -webkit-text-decoration: none;
  text-decoration: none;
  background-color: rgba(75, 53, 255, 0.04);
  border: 1px solid #4B35FF;
}

@media (hover: none) {
  .emotion-49:hover {
    background-color: transparent;
  }
}

.emotion-49.Mui-disabled {
  color: #1C1B1F61;
  border: 1px solid #1C1B1F1F;
}

.emotion-49:hover {
  box-shadow: none;
}

.emotion-49.Mui-focusVisible {
  box-shadow: none;
}

.emotion-49:active {
  box-shadow: none;
}

.emotion-49.Mui-disabled {
  box-shadow: none;
}

.emotion-50 {
  display: inherit;
  margin-right: 8px;
  margin-left: -4px;
}

.emotion-50>*:nth-of-type(1) {
  font-size: 20px;
}

.emotion-52 {
  clip: rect(0 0 0 0);
  -webkit-clip-path: inset(50%);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
}

.emotion-69 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 16px;
}

<div
    class="MuiStack-root emotion-0"
  >
    <div
      class="MuiBox-root emotion-1"
    >
      <div
        class="MuiStack-root emotion-2"
      >
        <div
          class="MuiStack-root emotion-3"
        >
          <div
            class="MuiBox-root emotion-4"
          >
            <div
              class="MuiStack-root emotion-5"
            >
              <h3
                class="MuiTypography-root MuiTypography-titleMedium emotion-6"
              >
                Section 1
              </h3>
              <button
                aria-label="Edit Section Topic"
                class="MuiButtonBase-root MuiIconButton-root MuiIconButton-sizeMedium emotion-7"
                tabindex="0"
                type="button"
              >
                <svg
                  aria-hidden="true"
                  class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium emotion-8"
                  data-testid="EditIcon"
                  focusable="false"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
                  />
                </svg>
                <span
                  class="MuiTouchRipple-root emotion-9"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr
      class="MuiDivider-root MuiDivider-fullWidth emotion-10"
    />
    <div
      class="MuiStack-root emotion-11"
    >
      <div
        class="MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation0 MuiCard-root emotion-12"
      >
        <div
          class="MuiCardContent-root emotion-13"
        >
          <h3
            class="MuiTypography-root MuiTypography-titleMedium MuiTypography-gutterBottom emotion-14"
          >
            Lecture Step
          </h3>
          <div
            class="MuiStack-root emotion-15"
          >
            <div
              class="MuiStack-root emotion-16"
            >
              <span
                class="MuiTypography-root MuiTypography-labelLarge emotion-17"
              >
                Text
              </span>
              <p
                class="MuiTypography-root MuiTypography-bodyMedium MuiTypography-gutterBottom emotion-18"
              >
                This content explains the topic being taught in this section.
              </p>
              <div
                class="MuiBox-root emotion-19"
              >
                <div
                  class="MuiFormControl-root MuiFormControl-fullWidth MuiTextField-root emotion-20"
                  data-testid="Text-input"
                >
                  <div
                    class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-colorPrimary MuiInputBase-fullWidth MuiInputBase-formControl MuiInputBase-multiline emotion-21"
                  >
                    <textarea
                      aria-invalid="false"
                      class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputMultiline emotion-22"
                      id=":r0:"
                      style="height: 0px; overflow: hidden;"
                    />
                    <textarea
                      aria-hidden="true"
                      class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputMultiline emotion-22"
                      readonly=""
                      style="visibility: hidden; position: absolute; overflow: hidden; height: 0px; top: 0px; left: 0px; transform: translateZ(0); padding-top: 0px; padding-bottom: 0px; width: 100%;"
                      tabindex="-1"
                    />
                    <fieldset
                      aria-hidden="true"
                      class="MuiOutlinedInput-notchedOutline emotion-24"
                    >
                      <legend
                        class="emotion-25"
                      >
                        <span
                          class="notranslate"
                        >
                          ​
                        </span>
                      </legend>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="MuiBox-root emotion-26"
            >
              <span
                class="MuiTypography-root MuiTypography-labelLarge emotion-17"
                id="media-selection-radio-buttons-label"
              >
                Display
              </span>
              <p
                class="MuiTypography-root MuiTypography-bodyMedium MuiTypography-gutterBottom emotion-18"
              >
                How would you like to display the content for this step to the student?
              </p>
              <div
                class="MuiFormControl-root emotion-29"
              >
                <div
                  aria-labelledby="media-selection-radio-buttons-label"
                  class="MuiFormGroup-root emotion-30"
                  role="radiogroup"
                >
                  <label
                    class="MuiFormControlLabel-root MuiFormControlLabel-labelPlacementEnd emotion-31"
                  >
                    <span
                      class="MuiButtonBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall PrivateSwitchBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall Mui-checked MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall emotion-32"
                    >
                      <input
                        aria-label="default generated kyron video"
                        checked=""
                        class="PrivateSwitchBase-input emotion-33"
                        name="media-selection-radio-buttons"
                        type="radio"
                        value="kyron_video"
                      />
                      <span
                        class="emotion-34"
                      >
                        <svg
                          aria-hidden="true"
                          class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-35"
                          data-testid="RadioButtonUncheckedIcon"
                          focusable="false"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                          />
                        </svg>
                        <svg
                          aria-hidden="true"
                          class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-36"
                          data-testid="RadioButtonCheckedIcon"
                          focusable="false"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
                          />
                        </svg>
                      </span>
                      <span
                        class="MuiTouchRipple-root emotion-9"
                      />
                    </span>
                    <span
                      class="MuiTypography-root MuiTypography-bodyMedium MuiFormControlLabel-label emotion-38"
                    >
                      Use default Kyron generated text and audio
                    </span>
                  </label>
                  <div
                    class="MuiStack-root emotion-39"
                  >
                    <label
                      class="MuiFormControlLabel-root MuiFormControlLabel-labelPlacementEnd emotion-31"
                    >
                      <span
                        class="MuiButtonBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall PrivateSwitchBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall emotion-32"
                      >
                        <input
                          aria-label="user video"
                          class="PrivateSwitchBase-input emotion-33"
                          name="media-selection-radio-buttons"
                          type="radio"
                          value="user_video"
                        />
                        <span
                          class="emotion-34"
                        >
                          <svg
                            aria-hidden="true"
                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-35"
                            data-testid="RadioButtonUncheckedIcon"
                            focusable="false"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                            />
                          </svg>
                          <svg
                            aria-hidden="true"
                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-45"
                            data-testid="RadioButtonCheckedIcon"
                            focusable="false"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
                            />
                          </svg>
                        </span>
                        <span
                          class="MuiTouchRipple-root emotion-9"
                        />
                      </span>
                      <span
                        class="MuiTypography-root MuiTypography-bodyMedium MuiFormControlLabel-label emotion-38"
                      >
                        Upload my own video with audio
                      </span>
                    </label>
                    <div
                      class="MuiStack-root emotion-48"
                    >
                      <label
                        aria-disabled="true"
                        class="MuiButtonBase-root MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButton-colorPrimary MuiButton-disableElevation Mui-disabled MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButton-colorPrimary MuiButton-disableElevation emotion-49"
                        role="button"
                        tabindex="-1"
                      >
                        <span
                          class="MuiButton-icon MuiButton-startIcon MuiButton-iconSizeMedium emotion-50"
                        >
                          <svg
                            aria-hidden="true"
                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium emotion-8"
                            data-testid="UploadFileIcon"
                            focusable="false"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm4 18H6V4h7v5h5zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z"
                            />
                          </svg>
                        </span>
                        Choose video
                        <input
                          accept="video/mp4, video/quicktime"
                          class="emotion-52"
                          data-testid="file-uploader-input"
                          disabled=""
                          type="file"
                        />
                      </label>
                    </div>
                  </div>
                  <div
                    class="MuiStack-root emotion-39"
                  >
                    <label
                      class="MuiFormControlLabel-root MuiFormControlLabel-labelPlacementEnd emotion-31"
                    >
                      <span
                        class="MuiButtonBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall PrivateSwitchBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall emotion-32"
                      >
                        <input
                          aria-label="user image"
                          class="PrivateSwitchBase-input emotion-33"
                          name="media-selection-radio-buttons"
                          type="radio"
                          value="user_image_with_audio"
                        />
                        <span
                          class="emotion-34"
                        >
                          <svg
                            aria-hidden="true"
                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-35"
                            data-testid="RadioButtonUncheckedIcon"
                            focusable="false"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                            />
                          </svg>
                          <svg
                            aria-hidden="true"
                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-45"
                            data-testid="RadioButtonCheckedIcon"
                            focusable="false"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
                            />
                          </svg>
                        </span>
                        <span
                          class="MuiTouchRipple-root emotion-9"
                        />
                      </span>
                      <span
                        class="MuiTypography-root MuiTypography-bodyMedium MuiFormControlLabel-label emotion-38"
                      >
                        Upload my own image, use generated audio
                      </span>
                    </label>
                    <div
                      class="MuiStack-root emotion-48"
                    >
                      <label
                        aria-disabled="true"
                        class="MuiButtonBase-root MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButton-colorPrimary MuiButton-disableElevation Mui-disabled MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButton-colorPrimary MuiButton-disableElevation emotion-49"
                        role="button"
                        tabindex="-1"
                      >
                        <span
                          class="MuiButton-icon MuiButton-startIcon MuiButton-iconSizeMedium emotion-50"
                        >
                          <svg
                            aria-hidden="true"
                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium emotion-8"
                            data-testid="UploadFileIcon"
                            focusable="false"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm4 18H6V4h7v5h5zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z"
                            />
                          </svg>
                        </span>
                        Choose image
                        <input
                          accept="image/png, image/jpeg, image/jpg"
                          class="emotion-52"
                          data-testid="file-uploader-input"
                          disabled=""
                          type="file"
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation0 MuiCard-root emotion-12"
      >
        <div
          class="MuiCardContent-root emotion-13"
        >
          <div
            class="MuiStack-root emotion-69"
          >
            <h3
              class="MuiTypography-root MuiTypography-titleMedium MuiTypography-gutterBottom emotion-14"
            >
              Knowledge Check
            </h3>
            <div
              class="MuiStack-root emotion-15"
            >
              <div
                class="MuiStack-root emotion-16"
              >
                <span
                  class="MuiTypography-root MuiTypography-labelLarge emotion-17"
                >
                  Question
                </span>
                <p
                  class="MuiTypography-root MuiTypography-bodyMedium MuiTypography-gutterBottom emotion-18"
                >
                  Enter the question you want the student to answer.
                </p>
                <div
                  class="MuiBox-root emotion-19"
                >
                  <div
                    class="MuiFormControl-root MuiFormControl-fullWidth MuiTextField-root emotion-20"
                    data-testid="Question-input"
                  >
                    <div
                      class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-colorPrimary MuiInputBase-fullWidth MuiInputBase-formControl MuiInputBase-multiline emotion-21"
                    >
                      <textarea
                        aria-invalid="false"
                        class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputMultiline emotion-22"
                        id=":r2:"
                        style="height: 0px; overflow: hidden;"
                      />
                      <textarea
                        aria-hidden="true"
                        class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputMultiline emotion-22"
                        readonly=""
                        style="visibility: hidden; position: absolute; overflow: hidden; height: 0px; top: 0px; left: 0px; transform: translateZ(0); padding-top: 0px; padding-bottom: 0px; width: 100%;"
                        tabindex="-1"
                      />
                      <fieldset
                        aria-hidden="true"
                        class="MuiOutlinedInput-notchedOutline emotion-24"
                      >
                        <legend
                          class="emotion-25"
                        >
                          <span
                            class="notranslate"
                          >
                            ​
                          </span>
                        </legend>
                      </fieldset>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="MuiBox-root emotion-26"
              >
                <span
                  class="MuiTypography-root MuiTypography-labelLarge emotion-17"
                  id="media-selection-radio-buttons-label"
                >
                  Display
                </span>
                <p
                  class="MuiTypography-root MuiTypography-bodyMedium MuiTypography-gutterBottom emotion-18"
                >
                  How would you like to display the content for this step to the student?
                </p>
                <div
                  class="MuiFormControl-root emotion-29"
                >
                  <div
                    aria-labelledby="media-selection-radio-buttons-label"
                    class="MuiFormGroup-root emotion-30"
                    role="radiogroup"
                  >
                    <label
                      class="MuiFormControlLabel-root MuiFormControlLabel-labelPlacementEnd emotion-31"
                    >
                      <span
                        class="MuiButtonBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall PrivateSwitchBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall Mui-checked MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall emotion-32"
                      >
                        <input
                          aria-label="default generated kyron video"
                          checked=""
                          class="PrivateSwitchBase-input emotion-33"
                          name="media-selection-radio-buttons"
                          type="radio"
                          value="kyron_video"
                        />
                        <span
                          class="emotion-34"
                        >
                          <svg
                            aria-hidden="true"
                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-35"
                            data-testid="RadioButtonUncheckedIcon"
                            focusable="false"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                            />
                          </svg>
                          <svg
                            aria-hidden="true"
                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-36"
                            data-testid="RadioButtonCheckedIcon"
                            focusable="false"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
                            />
                          </svg>
                        </span>
                        <span
                          class="MuiTouchRipple-root emotion-9"
                        />
                      </span>
                      <span
                        class="MuiTypography-root MuiTypography-bodyMedium MuiFormControlLabel-label emotion-38"
                      >
                        Use default Kyron generated text and audio
                      </span>
                    </label>
                    <div
                      class="MuiStack-root emotion-39"
                    >
                      <label
                        class="MuiFormControlLabel-root MuiFormControlLabel-labelPlacementEnd emotion-31"
                      >
                        <span
                          class="MuiButtonBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall PrivateSwitchBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall emotion-32"
                        >
                          <input
                            aria-label="user video"
                            class="PrivateSwitchBase-input emotion-33"
                            name="media-selection-radio-buttons"
                            type="radio"
                            value="user_video"
                          />
                          <span
                            class="emotion-34"
                          >
                            <svg
                              aria-hidden="true"
                              class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-35"
                              data-testid="RadioButtonUncheckedIcon"
                              focusable="false"
                              viewBox="0 0 24 24"
                            >
                              <path
                                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                              />
                            </svg>
                            <svg
                              aria-hidden="true"
                              class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-45"
                              data-testid="RadioButtonCheckedIcon"
                              focusable="false"
                              viewBox="0 0 24 24"
                            >
                              <path
                                d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
                              />
                            </svg>
                          </span>
                          <span
                            class="MuiTouchRipple-root emotion-9"
                          />
                        </span>
                        <span
                          class="MuiTypography-root MuiTypography-bodyMedium MuiFormControlLabel-label emotion-38"
                        >
                          Upload my own video with audio
                        </span>
                      </label>
                      <div
                        class="MuiStack-root emotion-48"
                      >
                        <label
                          aria-disabled="true"
                          class="MuiButtonBase-root MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButton-colorPrimary MuiButton-disableElevation Mui-disabled MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButton-colorPrimary MuiButton-disableElevation emotion-49"
                          role="button"
                          tabindex="-1"
                        >
                          <span
                            class="MuiButton-icon MuiButton-startIcon MuiButton-iconSizeMedium emotion-50"
                          >
                            <svg
                              aria-hidden="true"
                              class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium emotion-8"
                              data-testid="UploadFileIcon"
                              focusable="false"
                              viewBox="0 0 24 24"
                            >
                              <path
                                d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm4 18H6V4h7v5h5zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z"
                              />
                            </svg>
                          </span>
                          Choose video
                          <input
                            accept="video/mp4, video/quicktime"
                            class="emotion-52"
                            data-testid="file-uploader-input"
                            disabled=""
                            type="file"
                          />
                        </label>
                      </div>
                    </div>
                    <div
                      class="MuiStack-root emotion-39"
                    >
                      <label
                        class="MuiFormControlLabel-root MuiFormControlLabel-labelPlacementEnd emotion-31"
                      >
                        <span
                          class="MuiButtonBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall PrivateSwitchBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall emotion-32"
                        >
                          <input
                            aria-label="user image"
                            class="PrivateSwitchBase-input emotion-33"
                            name="media-selection-radio-buttons"
                            type="radio"
                            value="user_image_with_audio"
                          />
                          <span
                            class="emotion-34"
                          >
                            <svg
                              aria-hidden="true"
                              class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-35"
                              data-testid="RadioButtonUncheckedIcon"
                              focusable="false"
                              viewBox="0 0 24 24"
                            >
                              <path
                                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                              />
                            </svg>
                            <svg
                              aria-hidden="true"
                              class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-45"
                              data-testid="RadioButtonCheckedIcon"
                              focusable="false"
                              viewBox="0 0 24 24"
                            >
                              <path
                                d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
                              />
                            </svg>
                          </span>
                          <span
                            class="MuiTouchRipple-root emotion-9"
                          />
                        </span>
                        <span
                          class="MuiTypography-root MuiTypography-bodyMedium MuiFormControlLabel-label emotion-38"
                        >
                          Upload my own image, use generated audio
                        </span>
                      </label>
                      <div
                        class="MuiStack-root emotion-48"
                      >
                        <label
                          aria-disabled="true"
                          class="MuiButtonBase-root MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButton-colorPrimary MuiButton-disableElevation Mui-disabled MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButton-colorPrimary MuiButton-disableElevation emotion-49"
                          role="button"
                          tabindex="-1"
                        >
                          <span
                            class="MuiButton-icon MuiButton-startIcon MuiButton-iconSizeMedium emotion-50"
                          >
                            <svg
                              aria-hidden="true"
                              class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium emotion-8"
                              data-testid="UploadFileIcon"
                              focusable="false"
                              viewBox="0 0 24 24"
                            >
                              <path
                                d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm4 18H6V4h7v5h5zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z"
                              />
                            </svg>
                          </span>
                          Choose image
                          <input
                            accept="image/png, image/jpeg, image/jpg"
                            class="emotion-52"
                            data-testid="file-uploader-input"
                            disabled=""
                            type="file"
                          />
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="MuiStack-root emotion-16"
              >
                <span
                  class="MuiTypography-root MuiTypography-labelLarge emotion-17"
                >
                  Correct Response(s)
                </span>
                <p
                  class="MuiTypography-root MuiTypography-bodyMedium MuiTypography-gutterBottom emotion-18"
                >
                  Provide an example of a correct response to the question to help our A.I. guide the student during the lesson.
                </p>
                <div
                  class="MuiBox-root emotion-19"
                >
                  <div
                    class="MuiFormControl-root MuiFormControl-fullWidth MuiTextField-root emotion-20"
                    data-testid="Correct Response(s)-input"
                  >
                    <div
                      class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-colorPrimary MuiInputBase-fullWidth MuiInputBase-formControl MuiInputBase-multiline emotion-21"
                    >
                      <textarea
                        aria-invalid="false"
                        class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputMultiline emotion-22"
                        id=":r4:"
                        style="height: 0px; overflow: hidden;"
                      />
                      <textarea
                        aria-hidden="true"
                        class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputMultiline emotion-22"
                        readonly=""
                        style="visibility: hidden; position: absolute; overflow: hidden; height: 0px; top: 0px; left: 0px; transform: translateZ(0); padding-top: 0px; padding-bottom: 0px; width: 100%;"
                        tabindex="-1"
                      />
                      <fieldset
                        aria-hidden="true"
                        class="MuiOutlinedInput-notchedOutline emotion-24"
                      >
                        <legend
                          class="emotion-25"
                        >
                          <span
                            class="notranslate"
                          >
                            ​
                          </span>
                        </legend>
                      </fieldset>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</DocumentFragment>
`;

exports[`SectionDetail renders the section correctly with multiple choice 1`] = `
<DocumentFragment>
  .emotion-0 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
}

.emotion-1 {
  padding: 16px;
}

.emotion-2 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 32px;
}

.emotion-3 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.emotion-4 {
  max-width: 600px;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

.emotion-5 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.emotion-6 {
  margin: 0;
  font-family: Open Sans;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
}

.emotion-7 {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  background-color: transparent;
  outline: 0;
  border: 0;
  margin: 0;
  border-radius: 0;
  padding: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  vertical-align: middle;
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-text-decoration: none;
  text-decoration: none;
  color: inherit;
  text-align: center;
  -webkit-flex: 0 0 auto;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  font-size: 1.5rem;
  padding: 8px;
  border-radius: 50%;
  overflow: visible;
  color: rgba(0, 0, 0, 0.54);
  -webkit-transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

.emotion-7::-moz-focus-inner {
  border-style: none;
}

.emotion-7.Mui-disabled {
  pointer-events: none;
  cursor: default;
}

@media print {
  .emotion-7 {
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
  }
}

.emotion-7:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

@media (hover: none) {
  .emotion-7:hover {
    background-color: transparent;
  }
}

.emotion-7.Mui-disabled {
  background-color: transparent;
  color: #1C1B1F61;
}

.emotion-8 {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 1em;
  height: 1em;
  display: inline-block;
  fill: currentColor;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-size: 1.5rem;
}

.emotion-9 {
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  z-index: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: inherit;
}

.emotion-10 {
  margin: 0;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  border-width: 0;
  border-style: solid;
  border-color: #D6D5DD;
  border-bottom-width: thin;
}

.emotion-11 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  overflow-y: auto;
  padding: 24px;
  gap: 8px;
}

.emotion-12 {
  background-color: #FCFAFD;
  color: #1C1B1F;
  -webkit-transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border-radius: 8px;
  box-shadow: none;
  background-image: none;
  border-radius: 24px;
  overflow: hidden;
  background-color: #F1ECF4;
}

.emotion-13 {
  padding: 16px;
}

.emotion-13:last-child {
  padding-bottom: 24px;
}

.emotion-14 {
  margin: 0;
  font-family: Open Sans;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 0.35em;
}

.emotion-15 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 8px;
}

.emotion-16 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 4px;
}

.emotion-17 {
  margin: 0;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}

.emotion-18 {
  margin: 0;
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 0.35em;
}

.emotion-19 {
  position: relative;
}

.emotion-20 {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  position: relative;
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
  vertical-align: top;
  width: 100%;
}

.emotion-21 {
  color: #1C1B1F;
  line-height: 1.4375em;
  box-sizing: border-box;
  position: relative;
  cursor: text;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 4px 0 5px;
  width: 100%;
  position: relative;
  border-radius: 8px;
  padding: 16.5px 14px;
}

.emotion-21.Mui-disabled {
  color: #1C1B1F61;
  cursor: default;
}

.emotion-21:hover .MuiOutlinedInput-notchedOutline {
  border-color: #1C1B1F;
}

@media (hover: none) {
  .emotion-21:hover .MuiOutlinedInput-notchedOutline {
    border-color: rgba(0, 0, 0, 0.23);
  }
}

.emotion-21.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #4B35FF;
  border-width: 2px;
}

.emotion-21.Mui-error .MuiOutlinedInput-notchedOutline {
  border-color: #BA1A1A;
}

.emotion-21.Mui-disabled .MuiOutlinedInput-notchedOutline {
  border-color: #1C1B1F61;
}

.emotion-22 {
  font: inherit;
  letter-spacing: inherit;
  color: currentColor;
  padding: 0;
  border: 0;
  box-sizing: content-box;
  background: none;
  height: auto;
  margin: 0;
  -webkit-tap-highlight-color: transparent;
  display: block;
  min-width: 0;
  width: 100%;
  -webkit-animation-name: mui-auto-fill-cancel;
  animation-name: mui-auto-fill-cancel;
  -webkit-animation-duration: 10ms;
  animation-duration: 10ms;
  resize: none;
  padding-top: 0;
  padding: 0;
}

.emotion-22::-webkit-input-placeholder {
  color: currentColor;
  opacity: 0.42;
  -webkit-transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

.emotion-22::-moz-placeholder {
  color: currentColor;
  opacity: 0.42;
  -webkit-transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

.emotion-22:-ms-input-placeholder {
  color: currentColor;
  opacity: 0.42;
  -webkit-transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

.emotion-22::-ms-input-placeholder {
  color: currentColor;
  opacity: 0.42;
  -webkit-transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

.emotion-22:focus {
  outline: 0;
}

.emotion-22:invalid {
  box-shadow: none;
}

.emotion-22::-webkit-search-decoration {
  -webkit-appearance: none;
}

label[data-shrink=false]+.MuiInputBase-formControl .emotion-22::-webkit-input-placeholder {
  opacity: 0!important;
}

label[data-shrink=false]+.MuiInputBase-formControl .emotion-22::-moz-placeholder {
  opacity: 0!important;
}

label[data-shrink=false]+.MuiInputBase-formControl .emotion-22:-ms-input-placeholder {
  opacity: 0!important;
}

label[data-shrink=false]+.MuiInputBase-formControl .emotion-22::-ms-input-placeholder {
  opacity: 0!important;
}

label[data-shrink=false]+.MuiInputBase-formControl .emotion-22:focus::-webkit-input-placeholder {
  opacity: 0.42;
}

label[data-shrink=false]+.MuiInputBase-formControl .emotion-22:focus::-moz-placeholder {
  opacity: 0.42;
}

label[data-shrink=false]+.MuiInputBase-formControl .emotion-22:focus:-ms-input-placeholder {
  opacity: 0.42;
}

label[data-shrink=false]+.MuiInputBase-formControl .emotion-22:focus::-ms-input-placeholder {
  opacity: 0.42;
}

.emotion-22.Mui-disabled {
  opacity: 1;
  -webkit-text-fill-color: #1C1B1F61;
}

.emotion-22:-webkit-autofill {
  -webkit-animation-duration: 5000s;
  animation-duration: 5000s;
  -webkit-animation-name: mui-auto-fill;
  animation-name: mui-auto-fill;
}

.emotion-22:-webkit-autofill {
  border-radius: inherit;
}

.emotion-24 {
  text-align: left;
  position: absolute;
  bottom: 0;
  right: 0;
  top: -5px;
  left: 0;
  margin: 0;
  padding: 0 8px;
  pointer-events: none;
  border-radius: inherit;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  min-width: 0%;
  border-color: rgba(0, 0, 0, 0.23);
}

.emotion-25 {
  float: unset;
  width: auto;
  overflow: hidden;
  padding: 0;
  line-height: 11px;
  -webkit-transition: width 150ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
  transition: width 150ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
}

.emotion-29 {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  position: relative;
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
  vertical-align: top;
  padding-left: 8px;
}

.emotion-30 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  gap: 8px;
}

.emotion-31 {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  cursor: pointer;
  vertical-align: middle;
  -webkit-tap-highlight-color: transparent;
  margin-left: -11px;
  margin-right: 16px;
}

.emotion-31.Mui-disabled {
  cursor: default;
}

.emotion-31 .MuiFormControlLabel-label.Mui-disabled {
  color: #1C1B1F61;
}

.emotion-32 {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  background-color: transparent;
  outline: 0;
  border: 0;
  margin: 0;
  border-radius: 0;
  padding: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  vertical-align: middle;
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-text-decoration: none;
  text-decoration: none;
  color: inherit;
  padding: 9px;
  border-radius: 50%;
  color: #1C1B1FB3;
}

.emotion-32::-moz-focus-inner {
  border-style: none;
}

.emotion-32.Mui-disabled {
  pointer-events: none;
  cursor: default;
}

@media print {
  .emotion-32 {
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
  }
}

.emotion-32:hover {
  background-color: rgba(75, 53, 255, 0.04);
}

@media (hover: none) {
  .emotion-32:hover {
    background-color: transparent;
  }
}

.emotion-32.Mui-checked {
  color: #4B35FF;
}

.emotion-32.Mui-disabled {
  color: #1C1B1F61;
}

.emotion-33 {
  cursor: inherit;
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  z-index: 1;
}

.emotion-34 {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.emotion-35 {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 1em;
  height: 1em;
  display: inline-block;
  fill: currentColor;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-size: 1.25rem;
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
}

.emotion-36 {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 1em;
  height: 1em;
  display: inline-block;
  fill: currentColor;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-size: 1.25rem;
  left: 0;
  position: absolute;
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
  -webkit-transition: -webkit-transform 150ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
  transition: transform 150ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
}

.emotion-38 {
  margin: 0;
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.emotion-39 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  gap: 16px;
}

.emotion-45 {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 1em;
  height: 1em;
  display: inline-block;
  fill: currentColor;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-size: 1.25rem;
  left: 0;
  position: absolute;
  -webkit-transform: scale(0);
  -moz-transform: scale(0);
  -ms-transform: scale(0);
  transform: scale(0);
  -webkit-transition: -webkit-transform 150ms cubic-bezier(0.4, 0, 1, 1) 0ms;
  transition: transform 150ms cubic-bezier(0.4, 0, 1, 1) 0ms;
}

.emotion-48 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  max-width: 600px;
  gap: 16px;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
}

.emotion-49 {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  background-color: transparent;
  outline: 0;
  border: 0;
  margin: 0;
  border-radius: 0;
  padding: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  vertical-align: middle;
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-text-decoration: none;
  text-decoration: none;
  color: inherit;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-transform: none;
  min-width: 64px;
  padding: 5px 15px;
  border-radius: 8px;
  -webkit-transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border: 1px solid rgba(75, 53, 255, 0.5);
  color: #4B35FF;
  box-shadow: none;
  border-radius: 100px;
  text-transform: none;
  padding: 10px 24px;
  white-space: nowrap;
  min-width: -webkit-max-content;
  min-width: -moz-max-content;
  min-width: max-content;
  min-width: 156px;
}

.emotion-49::-moz-focus-inner {
  border-style: none;
}

.emotion-49.Mui-disabled {
  pointer-events: none;
  cursor: default;
}

@media print {
  .emotion-49 {
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
  }
}

.emotion-49:hover {
  -webkit-text-decoration: none;
  text-decoration: none;
  background-color: rgba(75, 53, 255, 0.04);
  border: 1px solid #4B35FF;
}

@media (hover: none) {
  .emotion-49:hover {
    background-color: transparent;
  }
}

.emotion-49.Mui-disabled {
  color: #1C1B1F61;
  border: 1px solid #1C1B1F1F;
}

.emotion-49:hover {
  box-shadow: none;
}

.emotion-49.Mui-focusVisible {
  box-shadow: none;
}

.emotion-49:active {
  box-shadow: none;
}

.emotion-49.Mui-disabled {
  box-shadow: none;
}

.emotion-50 {
  display: inherit;
  margin-right: 8px;
  margin-left: -4px;
}

.emotion-50>*:nth-of-type(1) {
  font-size: 20px;
}

.emotion-52 {
  clip: rect(0 0 0 0);
  -webkit-clip-path: inset(50%);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
}

.emotion-69 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 16px;
}

.emotion-125 {
  background-color: #FCFAFD;
  color: #1C1B1F;
  -webkit-transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border-radius: 8px;
  box-shadow: none;
  background-image: none;
  border-radius: 24px;
  overflow: hidden;
  cursor: move;
  background-color: #E3DFFF;
  padding: 8px;
  padding-left: 16px;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}

.emotion-127 {
  margin: 0;
  font-family: Open Sans;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #4B35FF;
}

.emotion-128 {
  margin: 0;
  font-family: Open Sans;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #110068;
}

.emotion-129 {
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
}

.emotion-130 {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  background-color: transparent;
  outline: 0;
  border: 0;
  margin: 0;
  border-radius: 0;
  padding: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  vertical-align: middle;
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-text-decoration: none;
  text-decoration: none;
  color: inherit;
  text-align: center;
  -webkit-flex: 0 0 auto;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  font-size: 1.5rem;
  padding: 8px;
  border-radius: 50%;
  overflow: visible;
  color: rgba(0, 0, 0, 0.54);
  -webkit-transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  padding: 5px;
  font-size: 1.125rem;
}

.emotion-130::-moz-focus-inner {
  border-style: none;
}

.emotion-130.Mui-disabled {
  pointer-events: none;
  cursor: default;
}

@media print {
  .emotion-130 {
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
  }
}

.emotion-130:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

@media (hover: none) {
  .emotion-130:hover {
    background-color: transparent;
  }
}

.emotion-130.Mui-disabled {
  background-color: transparent;
  color: #1C1B1F61;
}

.emotion-133 {
  background-color: #FCFAFD;
  color: #1C1B1F;
  -webkit-transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border-radius: 8px;
  box-shadow: none;
  background-image: none;
  border-radius: 24px;
  overflow: hidden;
  cursor: move;
  background-color: #F0E2E9;
  padding: 8px;
  padding-left: 16px;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}

.emotion-135 {
  margin: 0;
  font-family: Open Sans;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #7A5367;
}

.emotion-136 {
  margin: 0;
  font-family: Open Sans;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #2F1123;
}

<div
    class="MuiStack-root emotion-0"
  >
    <div
      class="MuiBox-root emotion-1"
    >
      <div
        class="MuiStack-root emotion-2"
      >
        <div
          class="MuiStack-root emotion-3"
        >
          <div
            class="MuiBox-root emotion-4"
          >
            <div
              class="MuiStack-root emotion-5"
            >
              <h3
                class="MuiTypography-root MuiTypography-titleMedium emotion-6"
              >
                Section 1
              </h3>
              <button
                aria-label="Edit Section Topic"
                class="MuiButtonBase-root MuiIconButton-root MuiIconButton-sizeMedium emotion-7"
                tabindex="0"
                type="button"
              >
                <svg
                  aria-hidden="true"
                  class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium emotion-8"
                  data-testid="EditIcon"
                  focusable="false"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
                  />
                </svg>
                <span
                  class="MuiTouchRipple-root emotion-9"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr
      class="MuiDivider-root MuiDivider-fullWidth emotion-10"
    />
    <div
      class="MuiStack-root emotion-11"
    >
      <div
        class="MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation0 MuiCard-root emotion-12"
      >
        <div
          class="MuiCardContent-root emotion-13"
        >
          <h3
            class="MuiTypography-root MuiTypography-titleMedium MuiTypography-gutterBottom emotion-14"
          >
            Lecture Step
          </h3>
          <div
            class="MuiStack-root emotion-15"
          >
            <div
              class="MuiStack-root emotion-16"
            >
              <span
                class="MuiTypography-root MuiTypography-labelLarge emotion-17"
              >
                Text
              </span>
              <p
                class="MuiTypography-root MuiTypography-bodyMedium MuiTypography-gutterBottom emotion-18"
              >
                This content explains the topic being taught in this section.
              </p>
              <div
                class="MuiBox-root emotion-19"
              >
                <div
                  class="MuiFormControl-root MuiFormControl-fullWidth MuiTextField-root emotion-20"
                  data-testid="Text-input"
                >
                  <div
                    class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-colorPrimary MuiInputBase-fullWidth MuiInputBase-formControl MuiInputBase-multiline emotion-21"
                  >
                    <textarea
                      aria-invalid="false"
                      class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputMultiline emotion-22"
                      id=":r6:"
                      style="height: 0px; overflow: hidden;"
                    />
                    <textarea
                      aria-hidden="true"
                      class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputMultiline emotion-22"
                      readonly=""
                      style="visibility: hidden; position: absolute; overflow: hidden; height: 0px; top: 0px; left: 0px; transform: translateZ(0); padding-top: 0px; padding-bottom: 0px; width: 100%;"
                      tabindex="-1"
                    />
                    <fieldset
                      aria-hidden="true"
                      class="MuiOutlinedInput-notchedOutline emotion-24"
                    >
                      <legend
                        class="emotion-25"
                      >
                        <span
                          class="notranslate"
                        >
                          ​
                        </span>
                      </legend>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="MuiBox-root emotion-26"
            >
              <span
                class="MuiTypography-root MuiTypography-labelLarge emotion-17"
                id="media-selection-radio-buttons-label"
              >
                Display
              </span>
              <p
                class="MuiTypography-root MuiTypography-bodyMedium MuiTypography-gutterBottom emotion-18"
              >
                How would you like to display the content for this step to the student?
              </p>
              <div
                class="MuiFormControl-root emotion-29"
              >
                <div
                  aria-labelledby="media-selection-radio-buttons-label"
                  class="MuiFormGroup-root emotion-30"
                  role="radiogroup"
                >
                  <label
                    class="MuiFormControlLabel-root MuiFormControlLabel-labelPlacementEnd emotion-31"
                  >
                    <span
                      class="MuiButtonBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall PrivateSwitchBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall Mui-checked MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall emotion-32"
                    >
                      <input
                        aria-label="default generated kyron video"
                        checked=""
                        class="PrivateSwitchBase-input emotion-33"
                        name="media-selection-radio-buttons"
                        type="radio"
                        value="kyron_video"
                      />
                      <span
                        class="emotion-34"
                      >
                        <svg
                          aria-hidden="true"
                          class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-35"
                          data-testid="RadioButtonUncheckedIcon"
                          focusable="false"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                          />
                        </svg>
                        <svg
                          aria-hidden="true"
                          class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-36"
                          data-testid="RadioButtonCheckedIcon"
                          focusable="false"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
                          />
                        </svg>
                      </span>
                      <span
                        class="MuiTouchRipple-root emotion-9"
                      />
                    </span>
                    <span
                      class="MuiTypography-root MuiTypography-bodyMedium MuiFormControlLabel-label emotion-38"
                    >
                      Use default Kyron generated text and audio
                    </span>
                  </label>
                  <div
                    class="MuiStack-root emotion-39"
                  >
                    <label
                      class="MuiFormControlLabel-root MuiFormControlLabel-labelPlacementEnd emotion-31"
                    >
                      <span
                        class="MuiButtonBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall PrivateSwitchBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall emotion-32"
                      >
                        <input
                          aria-label="user video"
                          class="PrivateSwitchBase-input emotion-33"
                          name="media-selection-radio-buttons"
                          type="radio"
                          value="user_video"
                        />
                        <span
                          class="emotion-34"
                        >
                          <svg
                            aria-hidden="true"
                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-35"
                            data-testid="RadioButtonUncheckedIcon"
                            focusable="false"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                            />
                          </svg>
                          <svg
                            aria-hidden="true"
                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-45"
                            data-testid="RadioButtonCheckedIcon"
                            focusable="false"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
                            />
                          </svg>
                        </span>
                        <span
                          class="MuiTouchRipple-root emotion-9"
                        />
                      </span>
                      <span
                        class="MuiTypography-root MuiTypography-bodyMedium MuiFormControlLabel-label emotion-38"
                      >
                        Upload my own video with audio
                      </span>
                    </label>
                    <div
                      class="MuiStack-root emotion-48"
                    >
                      <label
                        aria-disabled="true"
                        class="MuiButtonBase-root MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButton-colorPrimary MuiButton-disableElevation Mui-disabled MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButton-colorPrimary MuiButton-disableElevation emotion-49"
                        role="button"
                        tabindex="-1"
                      >
                        <span
                          class="MuiButton-icon MuiButton-startIcon MuiButton-iconSizeMedium emotion-50"
                        >
                          <svg
                            aria-hidden="true"
                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium emotion-8"
                            data-testid="UploadFileIcon"
                            focusable="false"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm4 18H6V4h7v5h5zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z"
                            />
                          </svg>
                        </span>
                        Choose video
                        <input
                          accept="video/mp4, video/quicktime"
                          class="emotion-52"
                          data-testid="file-uploader-input"
                          disabled=""
                          type="file"
                        />
                      </label>
                    </div>
                  </div>
                  <div
                    class="MuiStack-root emotion-39"
                  >
                    <label
                      class="MuiFormControlLabel-root MuiFormControlLabel-labelPlacementEnd emotion-31"
                    >
                      <span
                        class="MuiButtonBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall PrivateSwitchBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall emotion-32"
                      >
                        <input
                          aria-label="user image"
                          class="PrivateSwitchBase-input emotion-33"
                          name="media-selection-radio-buttons"
                          type="radio"
                          value="user_image_with_audio"
                        />
                        <span
                          class="emotion-34"
                        >
                          <svg
                            aria-hidden="true"
                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-35"
                            data-testid="RadioButtonUncheckedIcon"
                            focusable="false"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                            />
                          </svg>
                          <svg
                            aria-hidden="true"
                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-45"
                            data-testid="RadioButtonCheckedIcon"
                            focusable="false"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
                            />
                          </svg>
                        </span>
                        <span
                          class="MuiTouchRipple-root emotion-9"
                        />
                      </span>
                      <span
                        class="MuiTypography-root MuiTypography-bodyMedium MuiFormControlLabel-label emotion-38"
                      >
                        Upload my own image, use generated audio
                      </span>
                    </label>
                    <div
                      class="MuiStack-root emotion-48"
                    >
                      <label
                        aria-disabled="true"
                        class="MuiButtonBase-root MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButton-colorPrimary MuiButton-disableElevation Mui-disabled MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButton-colorPrimary MuiButton-disableElevation emotion-49"
                        role="button"
                        tabindex="-1"
                      >
                        <span
                          class="MuiButton-icon MuiButton-startIcon MuiButton-iconSizeMedium emotion-50"
                        >
                          <svg
                            aria-hidden="true"
                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium emotion-8"
                            data-testid="UploadFileIcon"
                            focusable="false"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm4 18H6V4h7v5h5zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z"
                            />
                          </svg>
                        </span>
                        Choose image
                        <input
                          accept="image/png, image/jpeg, image/jpg"
                          class="emotion-52"
                          data-testid="file-uploader-input"
                          disabled=""
                          type="file"
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation0 MuiCard-root emotion-12"
      >
        <div
          class="MuiCardContent-root emotion-13"
        >
          <div
            class="MuiStack-root emotion-69"
          >
            <h3
              class="MuiTypography-root MuiTypography-titleMedium MuiTypography-gutterBottom emotion-14"
            >
              Knowledge Check
            </h3>
            <div
              class="MuiStack-root emotion-15"
            >
              <div
                class="MuiStack-root emotion-16"
              >
                <span
                  class="MuiTypography-root MuiTypography-labelLarge emotion-17"
                >
                  Multiple Choice Question
                </span>
                <p
                  class="MuiTypography-root MuiTypography-bodyMedium MuiTypography-gutterBottom emotion-18"
                >
                  After explaining this topic, ask the learner a question to assess their understanding.
                </p>
                <div
                  class="MuiBox-root emotion-19"
                >
                  <div
                    class="MuiFormControl-root MuiFormControl-fullWidth MuiTextField-root emotion-20"
                    data-testid="Multiple Choice Question-input"
                  >
                    <div
                      class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-colorPrimary MuiInputBase-fullWidth MuiInputBase-formControl MuiInputBase-multiline emotion-21"
                    >
                      <textarea
                        aria-invalid="false"
                        class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputMultiline emotion-22"
                        id=":r8:"
                        style="height: 0px; overflow: hidden;"
                      />
                      <textarea
                        aria-hidden="true"
                        class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputMultiline emotion-22"
                        readonly=""
                        style="visibility: hidden; position: absolute; overflow: hidden; height: 0px; top: 0px; left: 0px; transform: translateZ(0); padding-top: 0px; padding-bottom: 0px; width: 100%;"
                        tabindex="-1"
                      />
                      <fieldset
                        aria-hidden="true"
                        class="MuiOutlinedInput-notchedOutline emotion-24"
                      >
                        <legend
                          class="emotion-25"
                        >
                          <span
                            class="notranslate"
                          >
                            ​
                          </span>
                        </legend>
                      </fieldset>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="MuiBox-root emotion-26"
              >
                <span
                  class="MuiTypography-root MuiTypography-labelLarge emotion-17"
                  id="media-selection-radio-buttons-label"
                >
                  Display
                </span>
                <p
                  class="MuiTypography-root MuiTypography-bodyMedium MuiTypography-gutterBottom emotion-18"
                >
                  How would you like to display the content for this step to the student?
                </p>
                <div
                  class="MuiFormControl-root emotion-29"
                >
                  <div
                    aria-labelledby="media-selection-radio-buttons-label"
                    class="MuiFormGroup-root emotion-30"
                    role="radiogroup"
                  >
                    <label
                      class="MuiFormControlLabel-root MuiFormControlLabel-labelPlacementEnd emotion-31"
                    >
                      <span
                        class="MuiButtonBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall PrivateSwitchBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall Mui-checked MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall emotion-32"
                      >
                        <input
                          aria-label="default generated kyron video"
                          checked=""
                          class="PrivateSwitchBase-input emotion-33"
                          name="media-selection-radio-buttons"
                          type="radio"
                          value="kyron_video"
                        />
                        <span
                          class="emotion-34"
                        >
                          <svg
                            aria-hidden="true"
                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-35"
                            data-testid="RadioButtonUncheckedIcon"
                            focusable="false"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                            />
                          </svg>
                          <svg
                            aria-hidden="true"
                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-36"
                            data-testid="RadioButtonCheckedIcon"
                            focusable="false"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
                            />
                          </svg>
                        </span>
                        <span
                          class="MuiTouchRipple-root emotion-9"
                        />
                      </span>
                      <span
                        class="MuiTypography-root MuiTypography-bodyMedium MuiFormControlLabel-label emotion-38"
                      >
                        Use default Kyron generated text and audio
                      </span>
                    </label>
                    <div
                      class="MuiStack-root emotion-39"
                    >
                      <label
                        class="MuiFormControlLabel-root MuiFormControlLabel-labelPlacementEnd emotion-31"
                      >
                        <span
                          class="MuiButtonBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall PrivateSwitchBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall emotion-32"
                        >
                          <input
                            aria-label="user video"
                            class="PrivateSwitchBase-input emotion-33"
                            name="media-selection-radio-buttons"
                            type="radio"
                            value="user_video"
                          />
                          <span
                            class="emotion-34"
                          >
                            <svg
                              aria-hidden="true"
                              class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-35"
                              data-testid="RadioButtonUncheckedIcon"
                              focusable="false"
                              viewBox="0 0 24 24"
                            >
                              <path
                                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                              />
                            </svg>
                            <svg
                              aria-hidden="true"
                              class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-45"
                              data-testid="RadioButtonCheckedIcon"
                              focusable="false"
                              viewBox="0 0 24 24"
                            >
                              <path
                                d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
                              />
                            </svg>
                          </span>
                          <span
                            class="MuiTouchRipple-root emotion-9"
                          />
                        </span>
                        <span
                          class="MuiTypography-root MuiTypography-bodyMedium MuiFormControlLabel-label emotion-38"
                        >
                          Upload my own video with audio
                        </span>
                      </label>
                      <div
                        class="MuiStack-root emotion-48"
                      >
                        <label
                          aria-disabled="true"
                          class="MuiButtonBase-root MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButton-colorPrimary MuiButton-disableElevation Mui-disabled MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButton-colorPrimary MuiButton-disableElevation emotion-49"
                          role="button"
                          tabindex="-1"
                        >
                          <span
                            class="MuiButton-icon MuiButton-startIcon MuiButton-iconSizeMedium emotion-50"
                          >
                            <svg
                              aria-hidden="true"
                              class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium emotion-8"
                              data-testid="UploadFileIcon"
                              focusable="false"
                              viewBox="0 0 24 24"
                            >
                              <path
                                d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm4 18H6V4h7v5h5zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z"
                              />
                            </svg>
                          </span>
                          Choose video
                          <input
                            accept="video/mp4, video/quicktime"
                            class="emotion-52"
                            data-testid="file-uploader-input"
                            disabled=""
                            type="file"
                          />
                        </label>
                      </div>
                    </div>
                    <div
                      class="MuiStack-root emotion-39"
                    >
                      <label
                        class="MuiFormControlLabel-root MuiFormControlLabel-labelPlacementEnd emotion-31"
                      >
                        <span
                          class="MuiButtonBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall PrivateSwitchBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall MuiRadio-root MuiRadio-colorPrimary MuiRadio-sizeSmall emotion-32"
                        >
                          <input
                            aria-label="user image"
                            class="PrivateSwitchBase-input emotion-33"
                            name="media-selection-radio-buttons"
                            type="radio"
                            value="user_image_with_audio"
                          />
                          <span
                            class="emotion-34"
                          >
                            <svg
                              aria-hidden="true"
                              class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-35"
                              data-testid="RadioButtonUncheckedIcon"
                              focusable="false"
                              viewBox="0 0 24 24"
                            >
                              <path
                                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                              />
                            </svg>
                            <svg
                              aria-hidden="true"
                              class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall emotion-45"
                              data-testid="RadioButtonCheckedIcon"
                              focusable="false"
                              viewBox="0 0 24 24"
                            >
                              <path
                                d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
                              />
                            </svg>
                          </span>
                          <span
                            class="MuiTouchRipple-root emotion-9"
                          />
                        </span>
                        <span
                          class="MuiTypography-root MuiTypography-bodyMedium MuiFormControlLabel-label emotion-38"
                        >
                          Upload my own image, use generated audio
                        </span>
                      </label>
                      <div
                        class="MuiStack-root emotion-48"
                      >
                        <label
                          aria-disabled="true"
                          class="MuiButtonBase-root MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButton-colorPrimary MuiButton-disableElevation Mui-disabled MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButton-colorPrimary MuiButton-disableElevation emotion-49"
                          role="button"
                          tabindex="-1"
                        >
                          <span
                            class="MuiButton-icon MuiButton-startIcon MuiButton-iconSizeMedium emotion-50"
                          >
                            <svg
                              aria-hidden="true"
                              class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium emotion-8"
                              data-testid="UploadFileIcon"
                              focusable="false"
                              viewBox="0 0 24 24"
                            >
                              <path
                                d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm4 18H6V4h7v5h5zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z"
                              />
                            </svg>
                          </span>
                          Choose image
                          <input
                            accept="image/png, image/jpeg, image/jpg"
                            class="emotion-52"
                            data-testid="file-uploader-input"
                            disabled=""
                            type="file"
                          />
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="MuiStack-root emotion-69"
              >
                <span
                  class="MuiTypography-root MuiTypography-labelLarge emotion-17"
                >
                  Multiple Choice Options
                </span>
                <div
                  class="MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation0 MuiCard-root emotion-125"
                >
                  <div
                    class="MuiBox-root emotion-26"
                  >
                    <p
                      class="MuiTypography-root MuiTypography-bodySmall emotion-127"
                    >
                      Correct
                    </p>
                    <p
                      class="MuiTypography-root MuiTypography-bodyLarge emotion-128"
                    >
                      choice-1
                    </p>
                  </div>
                  <div
                    class="MuiBox-root emotion-129"
                  >
                    <button
                      class="MuiButtonBase-root MuiIconButton-root MuiIconButton-sizeSmall emotion-130"
                      data-testid="edit-button-1"
                      tabindex="0"
                      type="button"
                    >
                      <svg
                        aria-hidden="true"
                        class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium emotion-8"
                        data-testid="EditIcon"
                        focusable="false"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
                        />
                      </svg>
                      <span
                        class="MuiTouchRipple-root emotion-9"
                      />
                    </button>
                  </div>
                </div>
                <div
                  class="MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation0 MuiCard-root emotion-133"
                >
                  <div
                    class="MuiBox-root emotion-26"
                  >
                    <p
                      class="MuiTypography-root MuiTypography-bodySmall emotion-135"
                    >
                      Incorrect
                    </p>
                    <p
                      class="MuiTypography-root MuiTypography-bodyLarge emotion-136"
                    >
                      choice-2
                    </p>
                  </div>
                  <div
                    class="MuiBox-root emotion-129"
                  >
                    <button
                      class="MuiButtonBase-root MuiIconButton-root MuiIconButton-sizeSmall emotion-130"
                      data-testid="edit-button-2"
                      tabindex="0"
                      type="button"
                    >
                      <svg
                        aria-hidden="true"
                        class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium emotion-8"
                        data-testid="EditIcon"
                        focusable="false"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
                        />
                      </svg>
                      <span
                        class="MuiTouchRipple-root emotion-9"
                      />
                    </button>
                  </div>
                </div>
                <div
                  class="MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation0 MuiCard-root emotion-133"
                >
                  <div
                    class="MuiBox-root emotion-26"
                  >
                    <p
                      class="MuiTypography-root MuiTypography-bodySmall emotion-135"
                    >
                      Incorrect
                    </p>
                    <p
                      class="MuiTypography-root MuiTypography-bodyLarge emotion-136"
                    >
                      choice-3
                    </p>
                  </div>
                  <div
                    class="MuiBox-root emotion-129"
                  >
                    <button
                      class="MuiButtonBase-root MuiIconButton-root MuiIconButton-sizeSmall emotion-130"
                      data-testid="edit-button-3"
                      tabindex="0"
                      type="button"
                    >
                      <svg
                        aria-hidden="true"
                        class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium emotion-8"
                        data-testid="EditIcon"
                        focusable="false"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
                        />
                      </svg>
                      <span
                        class="MuiTouchRipple-root emotion-9"
                      />
                    </button>
                  </div>
                </div>
                <div
                  class="MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation0 MuiCard-root emotion-133"
                >
                  <div
                    class="MuiBox-root emotion-26"
                  >
                    <p
                      class="MuiTypography-root MuiTypography-bodySmall emotion-135"
                    >
                      Incorrect
                    </p>
                    <p
                      class="MuiTypography-root MuiTypography-bodyLarge emotion-136"
                    >
                      I don't know
                    </p>
                  </div>
                  <div
                    class="MuiBox-root emotion-129"
                  >
                    <button
                      class="MuiButtonBase-root MuiIconButton-root MuiIconButton-sizeSmall emotion-130"
                      data-testid="edit-button-4"
                      tabindex="0"
                      type="button"
                    >
                      <svg
                        aria-hidden="true"
                        class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium emotion-8"
                        data-testid="EditIcon"
                        focusable="false"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
                        />
                      </svg>
                      <span
                        class="MuiTouchRipple-root emotion-9"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</DocumentFragment>
`;
